module.exports = __webpack_public_path__ + "img/制御工学5_8_4.9a19fb0e.png";